import { useEffect, useRef, useState } from "react";
import { useServerApi } from "./userServerApi";
import {
  normalizeProviderEmailPurposes,
  providerEmailPurposeOptions,
} from "../helpers/providerEmailPurposeUtils";

let cachedPurposes = null;
const listeners = new Set();

export const invalidateProviderEmailPurposes = () => {
  cachedPurposes = null;
  listeners.forEach((listener) => listener());
};

export const useProviderEmailPurposes = (currentValue) => {
  const [api] = useServerApi();
  const apiRef = useRef(api);
  apiRef.current = api;
  const [purposes, setPurposes] = useState(
    () => cachedPurposes ?? normalizeProviderEmailPurposes()
  );

  useEffect(() => {
    let active = true;

    const apply = (next) => {
      cachedPurposes = next;
      if (active) setPurposes(next);
    };

    const load = async () => {
      if (cachedPurposes) {
        if (active) setPurposes(cachedPurposes);
        return;
      }
      try {
        const result = await apiRef.current.search({
          apiEntity: "setting",
          pageSize: 1,
        });
        apply(
          normalizeProviderEmailPurposes(result?.docs?.[0]?.providerEmailPurposes)
        );
      } catch (error) {
        console.log(error);
        apply(normalizeProviderEmailPurposes());
      }
    };

    listeners.add(load);
    load();
    return () => {
      active = false;
      listeners.delete(load);
    };
  }, []);

  return {
    purposes,
    options: providerEmailPurposeOptions(purposes, currentValue),
  };
};
